var _a;
import planets from '../../data/planets.json';
import galastropods from '../../data/galastropods.json';
const getPlanet = (planetId) => {
    return planets[planetId];
};
const allPlanets = [];
for (const planet of Object.values(planets)) {
    const galastropod = (_a = Object.values(galastropods).find((g) => g.planet === planet.id)) === null || _a === void 0 ? void 0 : _a.id;
    allPlanets.push(Object.assign(Object.assign({}, planet), { galastropod }));
}
const getAllPlanets = () => {
    return allPlanets.sort((a, b) => a.orderToSun - b.orderToSun);
};
const getAllPlanetsMap = () => planets;
export { getAllPlanets, getAllPlanetsMap, getPlanet };
